module.exports = __webpack_public_path__ + "static/img/1.507ebc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/1.png
// module id = O0vK
// module chunks = 0